module.exports = __webpack_public_path__ + "img/logo.c6cfd289.png";